import { createTheme } from '@mui/material/styles';
import './tokens';

const legacyTheme = createTheme({
  cssVariables: true,
  palette: {
    navigation: {
      background:        '#204497',
      divider:           'rgba(255, 255, 255, 0.2)',
      tabSelectedBg:     'rgba(235, 31, 61, 0.15)',
      tabSelectedBorder: '#EB1F3D',
      link:              'rgba(255, 255, 255, 0.7)',
      badge:             '#9e9e9e',
      text:              '#ffffff',
      textMuted:         'rgba(255, 255, 255, 0.6)',
    },
  },
  typography: {
    fontFamily: "'Proxima Nova', sans-serif",
  },
});

export default legacyTheme;
